import React from "react";
import styles from "./TextInput.module.scss";
import { observer } from "mobx-react";

type TTextInput = {
  value: string;
  onChange?: (v: string) => void;
  onClick?: () => void;
  placeholder: string;
  error?: string;
  dataIcon?: string;
  readonly?: boolean;
  fullWidth?: boolean;
  isNumber?: boolean;
  minValue?: number;
  maxValue?: number;
};

const TextInput: React.FC<TTextInput> = observer(
  ({
    value,
    readonly,
    onChange,
    placeholder,
    error,
    fullWidth,
    onClick,
    dataIcon,
    isNumber = false,
    minValue,
    maxValue,
  }) => {
    const onTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const inputValue = e.target.value;

      if (isNumber && minValue !== undefined && maxValue !== undefined) {
        if (inputValue === "" || /^[0-9]+$/.test(inputValue)) {
          if (inputValue.length <= maxValue.toString().length) {
            onChange?.(inputValue);
          }
        }
      } else if (isNumber) {
        if (
          inputValue === "" ||
          (!isNaN(Number(inputValue)) &&
            Number(inputValue) >= (minValue ?? Number.MIN_SAFE_INTEGER) &&
            Number(inputValue) <= (maxValue ?? Number.MAX_SAFE_INTEGER))
        ) {
          onChange?.(inputValue);
        }
      } else {
        onChange?.(inputValue);
      }
    };

    const onBlur = () => {
      if (isNumber && minValue !== undefined && maxValue !== undefined) {
        const numericValue = Number(value);
        if (numericValue < minValue) {
          onChange?.(minValue.toString());
        } else if (numericValue > maxValue) {
          onChange?.(maxValue.toString());
        }
      }
    };

    return (
      <div className={styles.TextInputContainer}>
        <input
          onClick={onClick}
          data-error={!!error}
          type={isNumber ? "text" : "text"}
          inputMode={isNumber ? "numeric" : "text"}
          value={value}
          onChange={onTextChange}
          onBlur={minValue !== undefined && maxValue !== undefined ? onBlur : undefined}
          placeholder={placeholder}
          className={styles.TextInputContainer_Input}
          data-icon={dataIcon}
          readOnly={readonly}
          data-width-100={fullWidth}
        />
        {error && (
          <div className={styles.TextInputContainer_Error}>{error}</div>
        )}
      </div>
    );
  }
);

export default TextInput;
